import React, { useEffect, useRef } from "react";
import Footer from "../../../components/layout/Footer/Footer";
import { FrmttdPrc } from "../../../components/FormattedPrice/FormattedPrice";
import {
  Btn,
  Container,
  H1,
  H2,
  ImgContainer,
  Text1,
  Span,
  Block,
  ImgBlock,
  TitleBlock,
  TextBlock,
  Box,
  CircleText1,
  BoxText,
  BoxTitleB,
  BoxTitleN,
  CircleContainer,
  Box1,
  ImgCont,
  TextCont,
  TextBlock1,
  TitleBlock1,
  TextWrap,
  SmallText,
  Container1,
  Btn2,
  Span1,
  SmallText1,
  H1W,
  H2W,
  BtnW,
  FAQCont2,
  FAQuestion,
  Spinner,
  FAQCircle,
  FAQ1,
  InnerText,
  Companies,
  Box21q,
  Box2q,
  Boxq,
  Circlew,
} from "./styles";
import { goTo, useNavigation } from "../../../types/Navigates";
import {
  Btn5,
  BtnText,
  Circle,
  CircleText,
  Item,
  ItemContainer1,
  ItemContainer2,
  ItemContainer3,
  ItemText,
  Meeting,
  Price,
  ScrollContainer2,
  Smth,
  X,
} from "../../Main/styles";
import { FAQText } from "../../../components/FAQ/styles";
import { FAQ } from "../../../components/FAQ/FAQ";
import { Tag } from "../../../components/Ratings/styles";
import { Ratings } from "../../../components/Ratings/Ratings";
import { BookingPopup } from "../../../components/BookingPopUp/ThePopup/BookingPopup";
import urlText from "../../../types/urlText";
import { Block1Container, CircleContainer2 } from "../Services2/styles";
import { BoxTitleN2, BoxText2 } from "../Services1/styles";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getCard } from "../../../store/slices/cardSlice";
import { getProductCategories } from "../../../store/slices/productCategoriesSlice";

const Services6 = () => {
  const { toServices, toConsult, toMain, toRatings } = useNavigation();
  const scrollcontainerRef = useRef(null);
  const innerTextRef1 = useRef(null);
  const innerTextRef2 = useRef(null);
  const innerTextRef3 = useRef(null);
  const innerTextRef4 = useRef(null);
  const container1Ref = useRef(null);

  useEffect(() => {
    const scrollcontainer = scrollcontainerRef.current;
    const innerText1 = innerTextRef1.current;
    const innerText2 = innerTextRef2.current;
    const innerText3 = innerTextRef3.current;
    const innerText4 = innerTextRef4.current;
  });

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  useEffect(() => {
    dispatch(getCard(13));
    dispatch(getProductCategories());
  }, []);
  const card = useSelector((state: RootState) => state.card.card);
  const filteredProducts = card.filter(
    (item) => item.product_category.id === 13
  );
  console.log(filteredProducts);

  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const productCats = productCategories.find((item) => item.id === 13);

  const scroll = () => {
    if (scrollcontainerRef.current) {
      scrollcontainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const scroll2 = () => {
    if (container1Ref.current) {
      container1Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        container1Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const ShowinnerText1 = () => {
    if (innerTextRef1.current) {
      innerTextRef1.current.style.display == "none"
        ? (innerTextRef1.current.style.display = "block")
        : (innerTextRef1.current.style.display = "none");
    }
  };
  const ShowinnerText2 = () => {
    if (innerTextRef2.current) {
      innerTextRef2.current.style.display == "none"
        ? (innerTextRef2.current.style.display = "block")
        : (innerTextRef2.current.style.display = "none");
    }
  };
  const ShowinnerText3 = () => {
    if (innerTextRef3.current) {
      innerTextRef3.current.style.display == "none"
        ? (innerTextRef3.current.style.display = "block")
        : (innerTextRef3.current.style.display = "none");
    }
  };
  const ShowinnerText4 = () => {
    if (innerTextRef4.current) {
      innerTextRef4.current.style.display == "none"
        ? (innerTextRef4.current.style.display = "block")
        : (innerTextRef4.current.style.display = "none");
    }
  };
  const smthRef = useRef(null);
  const smth = smthRef.current;
  const ShowPopUp = () => {
    smthRef.current.style.display = "block";
    window.scrollTo(0, 0);
  };
  const HidePopUp = () => {
    smthRef.current.style.display = "none";
  };
  return (
    <>
      <Smth ref={smthRef}>
        <X onClick={HidePopUp} $img={require("../../Main/X.jpg")}></X>
        <BookingPopup />
      </Smth>
      <ImgContainer $img={require("./bg.png")}>
        {productCats ? <H1>{productCats.title}</H1> : <></>}
        <H2>
          Поможем быстро и качественно закрыть открытые позиции за приемлемую
          стоимость.
        </H2>
        <Btn onClick={goTo}>Бесплатная консультация</Btn>
      </ImgContainer>
      <Container>
        <Text1>
          Кому подходит
          <Span>сопровождение?</Span>
        </Text1>
      </Container>
      <Container>
        <Block>
          <ImgBlock $img={require("./v1.png")} />
          <TitleBlock>Создаете IT отдел с 0</TitleBlock>
          <TextBlock>Нет понимания как нанять IT специалистов</TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v2.png")} />
          <TitleBlock>Нужно было еще вчера</TitleBlock>
          <TextBlock>Горячая позиция, которая не закрывается</TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v3.png")} />
          <TitleBlock>Делегируете задачи</TitleBlock>
          <TextBlock>И доверяете профессионалам в IT подборе</TextBlock>
        </Block>
      </Container>
      <Text1>Как строится работа?</Text1>
      <Container>
        <Box>
          <CircleContainer2>
            <Circlew />
            <CircleText1>01</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Построим</BoxTitleN>
          <BoxTitleB>Прогнозы</BoxTitleB>
          <BoxText>Познакомимся, обсудим запрос, построим прогнозы</BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circlew />
            <CircleText1>02</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Заключаем</BoxTitleN>
          <BoxTitleB>Договор</BoxTitleB>
          <BoxText>Заключим договор и покажем первых кандидатов</BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circlew />
            <CircleText1>03</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Старт</BoxTitleN>
          <BoxTitleB>Работ</BoxTitleB>
          <BoxText>Закроем ваши позиции</BoxText>
        </Box>
        <Box1>
          <CircleContainer2>
            <Circlew />
            <CircleText1>04</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Получаем</BoxTitleN>
          <BoxTitleB>Результат</BoxTitleB>
          <BoxText>
            Поздравим вас и кандидата с успешным прохождением испытательного
            срока
          </BoxText>
        </Box1>
      </Container>
      <Text1>
        Что вы получите<Span>в итоге ?</Span>
      </Text1>
      <Container>
        <ImgCont $img={require("./bg2.png")} />
        <TextCont>
          <TextWrap>
            <TitleBlock1>Быстрое закрытие позиции</TitleBlock1>
            <TextBlock1>
              Только тех кандидатов, которые на 90% подходят под профиль
              позиции.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Высокую экспертизу IT найма</TitleBlock1>
            <TextBlock1>
              Мы всегда подсказываем клиентам как выгоднее выстроить процессы IT
              подбора, не теряя качества.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Выгодное закрытие вакансий</TitleBlock1>
            <TextBlock1>
              Мы работаем по пакетной системе закрытия вакансий, которая
              позволит вам сэкономить бюджет.
            </TextBlock1>
          </TextWrap>
        </TextCont>
      </Container>
      <SmallText>ТАРИФЫ</SmallText>
      <Text1>Как мы можем помочь</Text1>
      <Container1 ref={container1Ref}>
        <Block1Container>
          {filteredProducts && productCats ? (
            filteredProducts.map((product) => (
              <Item $img={require("./item23.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle />
                    <CircleText>{productCats.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
        </Block1Container>
      </Container1>
      <Text1>
        Мы приносим<Span>результат</Span>
      </Text1>
      <Container>
        <Boxq>
          <BoxTitleN2>100+</BoxTitleN2>
          <BoxText2>Закрытых вакансий</BoxText2>
        </Boxq>
        <Box2q>
          <BoxTitleN2>10 стран</BoxTitleN2>
          <BoxText2>Где мы имеем опыт подбора специалистов</BoxText2>
        </Box2q>
        <Box21q>
          <BoxTitleN2>4+</BoxTitleN2>
          <BoxText2>Года работы компании Prohorova Consult</BoxText2>
        </Box21q>
      </Container>
      <Text1>Отзывы</Text1>
      <ScrollContainer2 ref={scrollcontainerRef}>
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <ImgContainer $img={require("./bg3.png")}>
        <SmallText1>бесплатная консультация</SmallText1>
        <H1W>Остались вопросы ?</H1W>
        <H2W>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы.
        </H2W>
        <BtnW href={`https://t.me/ProhorovaConsult?text=${urlText}`}>
          Оставить заявку
        </BtnW>
      </ImgContainer>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <FAQ />
        <FAQCont2>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Какое среднее время закрытия позиций ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText1} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef1}>
            Среднее время закрытие позиций от 14 дней до 35 дней в зависимости
            от сложности позиции.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Вы работаете только с IT позициями ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText2} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef2}>
            Нет, мы со всеми позициями, но больший профиль у нас в ведении
            IT/Digital вакансий.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как юридически оформлена работа ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText3} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef3}>
            Мы заключаем договор, где прописаны все условия и критерии
            выполнения услуги.
          </InnerText>
        </FAQCont2>
      </Container>
      <Footer />
    </>
  );
};
export default Services6;
